import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import FormSelect from "../../../components/FormControls/FormSelect";
import TabBar from "../../../components/TabBar";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import BalanceSheetOpeningBalances from "./BalanceSheetOpeningBalances";
import BankReconciliationBalances from "./BankReconciliationBalances";

const StyledBalanceOpeningPage = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    background-color: ${(props) => props.theme.color.lightgray};
    padding: 45px;
    height: calc(100vh - 210px);
    overflow: auto;


`;

const PageContent = styled.div`
    width: 1000px;
    margin: auto;
`;

const TopLine = styled.div`
    width: 1000px;
    display: flex;
    margin: auto;
    padding-bottom: 15px;
`;

const PageTitle = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.color.dark};
    margin-top: auto;
`;

const BaseYear = styled.div`
    display: flex;
    font-size: 12px;
    margin-top: auto;
    margin-left: auto;
    align-items: center;
    color: ${(props) => props.theme.color.gray};
`;

const BaseYearLabel = styled.span`
    font-weight: 600;
`;

function BalanceOpeningPage(props) {

    let defaultPath = '/openingbalances/';

    let defaultTabPath = 'balancesheet';
    let {subTabPath} = useParams();

    let tabs = [
        {text: 'Balance sheet opening balances', path: 'balancesheet'},
        {text: 'Opening balance bank unreconciled items', path: 'unrecitems'},
    ];

    let currentYear = new Date().getFullYear();
    const [loadedPage, setLoadedPage] = useState(false);

    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    const onBaseYearChange = (e) => {
        props.setBaseYear(parseInt(e.target.value));
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setBaseYear(currentYear);
            setLoadedPage(true);
        }
    }, []);

    return (
        <StyledBalanceOpeningPage>
            <TopLine>
                <PageTitle>{'Opening / brought forward balances ' + props.baseYear}</PageTitle>
                <BaseYear>
                    <BaseYearLabel>Base year</BaseYearLabel>
                    <FormSelect items={years} value={props.baseYear} onChange={(e) => onBaseYearChange(e)} style={{display: 'flex', minWidth: 80, marginLeft: 15, paddingLeft: 7, paddingTop: 2, paddingBottom: 2}}></FormSelect>
                </BaseYear>
            </TopLine>

            <PageContent>
                <TabBar tabs={tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath}></TabBar>
                {subTabPath === 'balancesheet' && 
                    <BalanceSheetOpeningBalances {...props}></BalanceSheetOpeningBalances>
                }
                {subTabPath === 'unrecitems' && 
                    <BankReconciliationBalances {...props}></BankReconciliationBalances>
                }
            </PageContent>
            <NotificationContainer/>
        </StyledBalanceOpeningPage>
    )
}

export default BalanceOpeningPage;